import React from "react";
import "../Assets/css/index.css";
function UserAgreement() {
  return <div>UserAgreement</div>;
}

export default UserAgreement;
